import { array, struct } from 'io-ts/Decoder';

import { Id as CustomerId } from '../../../customer/Id';

export const Request = struct({
	customerIds: array(CustomerId),
});
